import "./benefits.scss";
import Image from "next/image";

export default function Benefits({ benefitsProps, allBenefits }) {
  return (
    <>
      {allBenefits.map((benefitSection, i) => {
        return (
          <div
            key={i}
            style={{
              background:
                i % 2 == 0
                  ? "linear-gradient(180deg, #e3f8ff 0%, #fbfdfe 100%"
                  : "#fff",
            }}
          >
            <div className="benefitsContainer">
              {i % 2 == 0 ? (
                <div className="benefitsImgContainer">
                  <Image
                    loading="lazy"
                    alt="benefit image"
                    src={benefitSection?.img?.url}
                    fill
                    style={{ objectFit: "cover" }}
                  />
                </div>
              ) : null}

              <div className="benefitsInfoWrapper">
                {benefitSection?.name ? (
                  <p className="heading">{benefitSection?.name}</p>
                ) : null}

                <div className="benefitsInfoContainer">
                  <p className="subHeading">
                    Benefits For
                    <span className="highlight">
                      {" "}
                      {benefitSection?.description}
                    </span>
                  </p>
                  <div className="benefitsInfo">
                    {benefitSection.benefit &&
                      benefitSection.benefit.map((benefit, i) => {
                        return (
                          <div key={i}>
                            <p className="features">{benefit?.title}</p>
                            <p className="benefit">{benefit?.description}</p>
                          </div>
                        );
                      })}
                  </div>
                </div>

                <button className="consultNowBtn">{benefitSection?.cta}</button>
              </div>

              {i % 2 == 1 ? (
                <div className="benefitsImgContainer">
                  <Image
                    loading="lazy"
                    alt="benefit image"
                    src={benefitSection?.img?.url}
                    fill
                    style={{ objectFit: "cover" }}
                  />
                </div>
              ) : null}
            </div>
          </div>
        );
      })}
    </>
  );
}
